import { render, staticRenderFns } from "./FormCustomInput.vue?vue&type=template&id=9d135436&scoped=true&"
import script from "./FormCustomInput.vue?vue&type=script&lang=ts&"
export * from "./FormCustomInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d135436",
  null
  
)

export default component.exports